<div [formGroup]="form">
  
    <div class="col-12">

        <div class="grid">
            <div class="col-1"></div>
            <div class="field grid">

                @if(offerFieldAttribute.required) {
                    <label [attr.for]="offerFieldAttribute.key" class="col-fixed label"
                        style="width: 17em">{{offerFieldAttribute.label}} (*)
                    </label>
                }
                @if(!offerFieldAttribute.required) {
                    <label [attr.for]="offerFieldAttribute.key" class="col-fixed label"
                        style="width: 17em">{{offerFieldAttribute.label}}
                    </label>
                }

                <!-- <div class="col" [ngSwitch]="offerFieldAttribute.controlType">

                    <input *ngSwitchCase="'textbox'" pInputText [id]="offerFieldAttribute.key" 
                        [pTooltip]="offerFieldAttribute.tooltip" tooltipPosition="top" [readonly]="offerFieldAttribute.readonly"
                        [style]="{'width': offerFieldAttribute.styleWidth}" (ngModelChange)="onTextChangeEvent(offerFieldAttribute.key, $event)"
                        [type]="offerFieldAttribute.type" [formControlName]="offerFieldAttribute.key" /> 
        
                    <p-select *ngSwitchCase="'dropdown'" [id]="offerFieldAttribute.key"
                        [pTooltip]="offerFieldAttribute.tooltip" tooltipPosition="top" [readonly]="offerFieldAttribute.readonly"
                        [options]="offerFieldAttribute.options" [formControlName]="offerFieldAttribute.key" [editable]="false" 
                        [style]="{'width': offerFieldAttribute.styleWidth}" (onChange)="onChangeEvent(offerFieldAttribute.key, $event)"> 
                    </p-select>
        
                    <p-checkbox *ngSwitchCase="'checkbox'" [formControlName]="offerFieldAttribute.key"
                        [(ngModel)]="offerFieldAttribute.checked" 
                        [pTooltip]="offerFieldAttribute.tooltip" tooltipPosition="top" [readonly]="offerFieldAttribute.readonly"
                        [id]="offerFieldAttribute.key" [binary]="true">
                    </p-checkbox>
        
                    <textarea *ngSwitchCase="'textarea'" pTextarea [id]="offerFieldAttribute.key" 
                        [style]="{'width': '100%'}" [rows]="offerFieldAttribute.rows" [cols]="offerFieldAttribute.cols" 
                        [pTooltip]="offerFieldAttribute.tooltip" tooltipPosition="top" [readonly]="offerFieldAttribute.readonly"
                        [formControlName]="offerFieldAttribute.key" > 
                    </textarea>
        
                    <input pInputText *ngSwitchCase="'colorpicker'" pTextarea [id]="offerFieldAttribute.key"
                        style="width: 20%;" [formControlName]="offerFieldAttribute.key"
                        [pTooltip]="offerFieldAttribute.tooltip" tooltipPosition="top" 
                        [style.background]="offerFieldAttribute.colorInit" 
                        [(colorPicker)]="offerFieldAttribute.colorInit"
                        [cpOKButton] = "true"
                        [cpOKButtonText] = "'Select'"
                        [cpCancelButton] = "true"
                        [cpSaveClickOutside] = "false"
                        [cpDisableInput]="false"
                        [cpAlphaChannel]="'disabled'" 
                        [cpOutputFormat]="'hex'"
                        [cpAddColorButton]="true"
                        [cpColorMode] ="'color'"   
                        [cpPresetLabel]="''"    
                        [cpPresetEmptyMessage]="''"  
                        (colorPickerChange)="onCaptureColor(offerFieldAttribute.key, $event)" 
                        (colorPickerSelect)="onCaptureColor(offerFieldAttribute.key, $event)"                       
                    />
        
                    @if(!isValid) {
                        <p-message severity="error">{{offerFieldAttribute.label}} required or invalid value</p-message>                 
                    }
        
    
                </div>     -->


<div class="col">
  @switch (offerFieldAttribute.controlType) {

    @case ('textbox') {
      <input
        pInputText
        [id]="offerFieldAttribute.key"
        [pTooltip]="offerFieldAttribute.tooltip"
        tooltipPosition="top"
        [readonly]="offerFieldAttribute.readonly"
        [style.width]="offerFieldAttribute.styleWidth"
        [type]="offerFieldAttribute.type"
        [formControlName]="offerFieldAttribute.key"
        (ngModelChange)="onTextChangeEvent(offerFieldAttribute.key, $event)"  
      />
    }

    @case ('dropdown') {
      <p-select
        [id]="offerFieldAttribute.key"
        [pTooltip]="offerFieldAttribute.tooltip"
        tooltipPosition="top"
        [readonly]="offerFieldAttribute.readonly"
        [options]="offerFieldAttribute.options"
        [editable]="false"
        [style.width]="offerFieldAttribute.styleWidth"
        [formControlName]="offerFieldAttribute.key"
        (onChange)="onChangeEvent(offerFieldAttribute.key, $event)">
      </p-select>
    }

    @case ('checkbox') {
      <p-checkbox
        [id]="offerFieldAttribute.key"
        [pTooltip]="offerFieldAttribute.tooltip"
        tooltipPosition="top"
        [readonly]="offerFieldAttribute.readonly"
        [binary]="true"
        [formControlName]="offerFieldAttribute.key">
      </p-checkbox>
      <!-- If you must reflect the checked state in the model, consider listening to valueChanges in TS -->
    }

    @case ('textarea') {
      <textarea
        pTextarea
        [id]="offerFieldAttribute.key"
        [style.width]="'100%'"
        [rows]="offerFieldAttribute.rows"
        [cols]="offerFieldAttribute.cols"
        [pTooltip]="offerFieldAttribute.tooltip"
        tooltipPosition="top"
        [readonly]="offerFieldAttribute.readonly"
        [formControlName]="offerFieldAttribute.key">
      </textarea>
    }

    @case ('colorpicker') {
      <!-- Remove stray pTextarea; keep pInputText + colorPicker directives -->
      <input
        pInputText
        [id]="offerFieldAttribute.key"
        [formControlName]="offerFieldAttribute.key"
        [pTooltip]="offerFieldAttribute.tooltip"
        tooltipPosition="top"
        [style.width]="'20%'"
        [style.background]="offerFieldAttribute.colorInit"
        [(colorPicker)]="offerFieldAttribute.colorInit"
        [cpOKButton]="true"
        [cpOKButtonText]="'Select'"
        [cpCancelButton]="true"
        [cpSaveClickOutside]="false"
        [cpDisableInput]="false"
        [cpAlphaChannel]="'disabled'"
        [cpOutputFormat]="'hex'"
        [cpAddColorButton]="true"
        [cpColorMode]="'color'"
        [cpPresetLabel]="''"
        [cpPresetEmptyMessage]="''"
        (colorPickerChange)="onCaptureColor(offerFieldAttribute.key, $event)"
        (colorPickerSelect)="onCaptureColor(offerFieldAttribute.key, $event)"
      />
    }

  }

  @if (!isValid) {
    <p-message severity="error">
      {{ offerFieldAttribute.label }} required or invalid value
    </p-message>
  }
</div>

                
            </div>
        </div>  

    
    </div>

</div>
